export const phoneNumber = '+6493747525';
export const phoneNumberFormatted = '+64 9 374 7525';

